import classes from "../../classes";
import { connect } from "react-redux";
import DateDropDown from "../../components/date-drop-down";
import DepositTransactionSummary from "../../components/deposit-transaction-summary";
import DisallowedMessage from "../../components/disallowed-message";
import expandable from "../../components/higher-order/expandable";
import FormError from "../../components/form-error";
import { getCommunications, getDeposit, getSession } from "../../selectors";
import { Map } from "immutable";
import React from "react";
import requireAuthentication from "../../components/higher-order/require-authentication";
import states from "../../states";
import HelpBox from "../../components/help-box";
import Step from "../../components/step";
import Steps from "../../components/steps";
import { updateBillingInformationDeposit } from "../../actions/session";
import { withRouter } from "react-router-dom";

class DepositAmountPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.toggleHelp = this.toggleHelp.bind(this);

    var { deposit, history } = props;
    if (!deposit.get("amount") || deposit.get("confirmed")) {
      history.push("/deposit");
    }
  }

  onSubmit(e) {
    var { session, updateBillingInformationDeposit: onUpdateBillingInformationDeposit } = this.props;
    e.preventDefault();
    var address = this.refs.address.value;
    var city = this.refs.city.value;
    var state = this.refs.state.value;
    var zip = this.refs.zip.value;
    var dob = this.refs.dob.value;
    onUpdateBillingInformationDeposit(session.get("user_id"), address, city, state, zip, dob);
  }

  toggleHelp(e) {
    var { toggle } = this.props;
    e.preventDefault();
    toggle();
  }

  render() {
    var { communications, deposit, expanded, session, toggle } = this.props;

    var billingAddress = session.get("billing_address");
    var stateElems = states.map(state => (
      <option key={state.abbr} value={state.abbr}>
        {state.name}
      </option>
    ));

    var dob;
    if (session.get("date_of_birth")) {
      var parts = session.get("date_of_birth").split("-");
      dob = new Date(parts[0], parts[1] - 1, parts[2]);
    }

    var help;
    if (expanded) {
      help = <DateOfBirthHelp onClose={toggle} />;
    }

    var errors = communications.getIn(["update_billing_information", "error"]) || Map();
    var isIdentityVerificationEnabled = (session.get("identity_verification_enabled") === true);
    var isIdentityVerified = (session.get("identity_verified") === true);
    var nextStep = (!isIdentityVerificationEnabled || isIdentityVerified) ? "Payment Method" : "ID Verification";

    if (errors.get("type") === "IdentityVerificationFailure") {
      return <DisallowedDeposit session={session} />;
    }

    return (
      <div className="l-wrapper">
        <div className="l-content l-content--80-percent">

          <Steps>
            <Step>
              Deposit Amount
            </Step>

            <Step selected>
              Billing Information
            </Step>

            <Step>
              {nextStep}
            </Step>

            <Step>
              Deposit Confirmation
            </Step>
          </Steps>

          <h1 className="text-center">
            Next We Need Your Billing Information
          </h1>

          <div className="batch-g batch-g--padding">
            <DepositTransactionSummary amount={deposit.get("amount")} />

            <div className="batch-c-1-1 batch-c-md-2-3 batch-c-order-md-1">
              <form className="form--is-horizontal" onSubmit={this.onSubmit}>
                <div className="batch-g batch-g--padding batch-g--valign-center">

                  <div className="batch-c-1-1 batch-c-md-1-4" />

                  <div className="batch-c-1-1 batch-c-md-3-4">
                    <FormError error={errors.get("id_verification")} name="ID Verification" />
                  </div>

                  <div className="batch-c-1-1 batch-c-md-1-4">
                    <label htmlFor="address">
                      Address
                    </label>
                  </div>

                  <div className="batch-c-1-1 batch-c-md-3-4">
                    <input className="form_input" defaultValue={billingAddress.get("address")} id="address" name="address" placeholder="Address" ref="address" type="text" />

                    <FormError error={errors.get("address")} name="Address" />
                  </div>

                  <div className="batch-c-1-1 batch-c-md-1-4">
                    <label htmlFor="city">
                      City
                    </label>
                  </div>

                  <div className="batch-c-1-1 batch-c-md-3-4">
                    <input className="form_input" defaultValue={billingAddress.get("city")} id="city" name="city" placeholder="City" ref="city" type="text" />

                    <FormError error={errors.get("city")} name="City" />
                  </div>

                  <div className="batch-c-1-1 batch-c-md-1-4">
                    <label htmlFor="state-zip">
                      State/ZIP
                    </label>
                  </div>

                  <div className="batch-c-1-1 batch-c-md-3-4">
                    <div className="batch-g">
                      <div className="batch-c-1-2 padding-right--is-10">
                        <div className="form_input form_input--select form_input--is-block">
                          <select defaultValue={billingAddress.get("state") || "Select State"} ref="state">
                            <option disabled>
                              Select State
                            </option>

                            {stateElems}
                          </select>
                        </div>

                        <FormError error={errors.get("state")} name="State" />
                      </div>

                      <div className="batch-c-1-2">
                        <input className="form_input" defaultValue={billingAddress.get("zip_code")} id="zip-code" name="zip-code" placeholder="ZIP Code" ref="zip" type="text" />

                        <FormError error={errors.get("zip_code")} name="ZIP Code" />
                      </div>
                    </div>
                  </div>

                  <div className="batch-c-1-1 batch-c-md-1-4">
                    <label htmlFor="name">
                      Date of Birth
                      {" "}

                      <button className="dw-help_outline dw--1-25x" onClick={this.toggleHelp} type="button" />
                    </label>
                  </div>

                  <div className="batch-c-1-1 batch-c-md-3-4">
                    <DateDropDown date={dob} ref="dob" />
                  </div>

                  <div className="batch-c-1-1 batch-c-md-1-4" />

                  <div className="batch-c-1-1 batch-c-md-3-4">
                    <FormError error={errors.get("date_of_birth")} name="Date of Birth" />
                  </div>

                  <div className="batch-c-1-1 batch-c-md-1-4" />

                  <div className="batch-c-1-1 batch-c-md-3-4">
                    <div className="form_action">
                      <input
                        className={classes({
                          "btn": true,
                          "btn--primary": true
                        })}
                        type="submit"
                        value="Continue" />
                    </div>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>

        {help}
      </div>
    );
  }
}
function DateOfBirthHelp({ onClose }) {
  return (
    <HelpBox onClose={onClose}>
      <h3>
        Why do you need my Date of Birth?
      </h3>

      <p>
        We need to verify your age because many states require players are at least 18 years old, whilst some states require players are at least 21 years old.
      </p>
    </HelpBox>
  );
}

function DisallowedDeposit({ session }) {
  return (
    <div className="l-wrapper">
      <div className="l-content l-content--80-percent">

        <h1 className="text-center">
          Deposit
        </h1>

        <DisallowedMessage session={session} />
      </div>
    </div>
  );
}

function select(state) {
  return {
    communications: getCommunications(state),
    deposit: getDeposit(state),
    session: getSession(state)
  };
}

export default connect(select, { updateBillingInformationDeposit })(requireAuthentication(withRouter(expandable(DepositAmountPage))));
